export interface DurationParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;

export const secondsToParts = (totalSeconds: number): DurationParts => {
  const safe = Number.isFinite(totalSeconds) && totalSeconds > 0 ? Math.floor(totalSeconds) : 0;
  return {
    days: Math.floor(safe / SECONDS_PER_DAY),
    hours: Math.floor((safe % SECONDS_PER_DAY) / SECONDS_PER_HOUR),
    minutes: Math.floor((safe % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE),
    seconds: safe % SECONDS_PER_MINUTE,
  };
};

export const partsToSeconds = (parts: DurationParts): number => {
  const { days = 0, hours = 0, minutes = 0, seconds = 0 } = parts;
  return days * SECONDS_PER_DAY + hours * SECONDS_PER_HOUR + minutes * SECONDS_PER_MINUTE + seconds;
};

const pluralize = (value: number, unit: string): string => `${value} ${unit}${value === 1 ? '' : 's'}`;

export const formatDuration = (totalSeconds: number): string => {
  const { days, hours, minutes, seconds } = secondsToParts(totalSeconds);
  const segments: string[] = [];
  if (days) segments.push(pluralize(days, 'day'));
  if (hours) segments.push(pluralize(hours, 'hour'));
  if (minutes) segments.push(pluralize(minutes, 'minute'));
  if (seconds) segments.push(pluralize(seconds, 'second'));
  return segments.length ? segments.join(', ') : '0 seconds';
};
